export const translations = {
  pt: {
    // Header
    home: "Início",
    problem: "O Problema",
    services: "Serviços",
    differentials: "Diferenciais",
    about: "Sobre",
    clients: "Clientes",
    contact: "Contato",
    language: "Idioma",
    portuguese: "Português",
    english: "Inglês",
    spanish: "Espanhol",
    italian: "Italiano",
    clientsTitle: 'Alguns de nossos <span class="highlight">clientes</span>',
    contactTitle: 'Entre em <span class="highlight">contato</span>',
    contactCta: "Clique aqui para conversar",
    addressLabel: "Endereço",
    backofficeTitle: "Pesquisa, Controladoria e Backoffice Jurídico",
    quickLinks: "Links rápidos",
    socialMedia: "Redes sociais",
    allRightsReserved: "Todos os direitos reservados.",
    testimonialsTitle:
      'O que <span class="highlight">nossos clientes</span> dizem',

    // Hero
    heroTitle: "Libere sua equipe da rotina <span>operacional</span>",
    heroSubtitle:
      "Todas as etapas do acompanhamento processual do seu escritório mapeadas e executadas de forma assertiva e segura",
    talkToSpecialists: "Fale com nossos especialistas",

    // Metrics
    processes: "Processos monitorados",
    lawyers: "Advogados assistidos",
    years: "Anos no mercado",

    // Problem
    problemTitle: 'O problema que <span class="highlight">resolvemos</span>',
    wastedTime: "Tempo desperdiçado",
    wastedTimeDesc:
      "Advogados gastam até 40% do seu tempo em tarefas que não envolvem sua expertise principal",
    lostDeadlines: "Prazos perdidos",
    lostDeadlinesDesc:
      "Falhas no acompanhamento processual podem resultar em perda de prazos e oportunidades",
    bureaucracy: "Sobrecarga burocrática",
    bureaucracyDesc:
      "Excesso de tarefas administrativas que competem com o tempo dedicado à advocacia",
    // Diferenciais
    differentialsTitle: 'Por que escolher a  <span class="highlight">Integrarq?</span>',

    differential1Title: "Trabalhamos na sua plataforma",
    differential1Desc:
      "Adaptação aos sistemas já utilizados (Legal One, LFM, Themis, etc.) sem necessidade de migração",

    differential2Title: "Apoio na transição de sistemas",
    differential2Desc:
      "Implantação assistida, saneamento de base e documentação de rotinas para uma migração tranquila",

    differential3Title: "Equipe especializada",
    differential3Desc:
      "Profissionais da advocacia, gestão e tecnologia com conhecimento técnico jurídico e foco em qualidade",
    missionTitle: "Missão",
    missionText:
      "Proporcionar aos nossos clientes suporte externo com expertise e excelência, para que eles possam atuar com foco exclusivo na representação dos seus clientes",

    visionTitle: "Visão",
    visionText:
      "Ser a melhor empresa de gestão da informação a oferecer soluções através de serviços personalizados, com foco em qualidade, aumento de produtividade, redução de custos e assertividade",

    valuesTitle: "Valores",
    valuesList: [
      "Ética",
      "Comprometimento",
      "Assertividade",
      "Qualidade",
      "Agilidade",
      "Autonomia",
      "Honestidade",
    ],

    aboutTitle: 'Sobre <span class="highlight">nós</span>',
    aboutP1:
      "A Integrarq foi fundada em 2010 por Ligia Werneck e Nathália Amaral Araújo, arquivistas formadas pela Universidade Federal Fluminense, com o propósito de oferecer soluções especializadas em organização documental.",
    aboutP2:
      "Ao longo do tempo, evoluímos para acompanhar as demandas do mercado jurídico e nos consolidamos como referência em terceirização de processos administrativos.",
    aboutP3:
      "Atuamos com metodologia própria, visão estratégica e atenção às particularidades de cada cliente. Nossa equipe é multidisciplinar, formada por profissionais das áreas de gestão, direito e tecnologia, comprometidos com a entrega de resultados concretos: aumento da produtividade, redução de custos operacionais e liberação de tempo da equipe interna para o que realmente importa.",

    // Services
    servicesTitle: 'Nossos <span class="highlight">serviços</span>',

    legalBackoffice: "Backoffice Jurídico",
    legalResearch: "Pesquisa Jurídica",
    documentManagement: "Gestão Processual",
    documentManagementDesc:
      "Cadastro de processos, contratos e clientes. Organização e arquivamento de peças processuais digitais",
    deadlineControl: "Controle de Prazos",
    deadlineControlDesc:
      "Agendamento de pautas, double-check de compromissos e alertas personalizados",
    operationalSupport: "Suporte Operacional",
    operationalSupportDesc:
      "Rotinas de Paralegal, tratamento das novas movimentações e rastreamento de recursos",
    dataOrganization: "Organização da Base",
    dataOrganizationDesc:
      "Saneamento e organização da base processual, alimentação de dados em sistemas jurídicos",
    publications: "Publicações",
    publicationsDesc:
      "Monitoramento e entrega de publicações relevantes, garantindo que os prazos não sejam perdidos",
    caseUpdates: "Andamentos",
    caseUpdatesDesc:
      "Rastreio e atualização dos andamentos processuais, mantendo a equipe sempre informada",
    electronicSummons: "Intimações Eletrônicas",
    electronicSummonsDesc:
      "Consulta aos painéis eletrônicos dos tribunais para localizar intimações expedidas",
    distributionsAndInquiries: "Novas Ações",
    distributionsAndInquiriesDesc:
      "Localizar novos processos distribuídos em 1º e 2º instâncias e superiores",
    // Contact
    name: "Nome",
    email: "E-mail",
    phone: "Telefone",
    message: "Mensagem",
    send: "Enviar mensagem",
    testimonial1:
      "Trabalho com a Integrarq desde a época em que cuidavam do arquivo em papel do escritório. Com o passar do tempo e o avanço da tecnologia, os processos se tornaram eletrônicos — e a Integrarq não apenas acompanhou essa transformação, como se reinventou. Hoje, continuam ao nosso lado, cuidando dos processos digitais com a mesma competência de sempre, e constantemente nos trazendo novas soluções e produtos.",
    testimonial1Client: "Escritório do Rio de Janeiro",

    testimonial2:
      "A precisão no acompanhamento processual e o suporte contínuo da equipe Integrarq foram fundamentais para o crescimento do nosso escritório.",
    testimonial2Client: "Escritório no Rio de Janeiro",

    testimonial3:
      "Trajetória marcada por profissionalismo, compromisso e parceria. É uma satisfação para nós contar com o apoio de uma equipe sempre tão dedicada e eficiente. No momento em que mais precisamos de  apoio, recebemos atenção aos detalhes e uma verdadeira parceria.",
    testimonial3Client: "Escritório em São Paulo",

    testimonial4:
      "A Integrarq realiza um trabalho de controladoria jurídica importante, não só para controle e cumprimento dos prazos, mas também para a busca de novas ações, permitindo ao escritório fornecer informação em primeira mão aos clientes e eventualmente antecipar estratégias. Outro serviço relevante é a análise quantitativa do trabalho desempenhado pelo escritório, o que ajuda em uma melhor alocação de recursos.",
    testimonial4Client: "Escritório em São Paulo",
  },

  en: {
    // Header
    home: "Home",
    problem: "The Problem",
    services: "Services",
    differentials: "Differentials",
    about: "About",
    clients: "Clients",
    contact: "Contact",
    language: "Language",
    portuguese: "Portuguese",
    english: "English",
    spanish: "Spanish",
    italian: "Italian",
    differentialsTitle: 'Our <span class="highlight">differentials</span>',
    testimonialsTitle: 'What <span class="highlight">our clients</span> say',
    addressLabel: "Address",
    backofficeTitle: "Legal Backoffice and Case Management",
    quickLinks: "Quick Links",
    socialMedia: "Social Media",
    allRightsReserved: "All rights reserved.",
    differential1Title: "We work on YOUR platform",
    differential1Desc:
      "Adaptation to existing systems (Legal One, LFM, Themis, etc.) with no need for migration.",

    differential2Title: "System transition support",
    differential2Desc:
      "Assisted implementation, database cleanup, and routine documentation for a smooth migration.",

    differential3Title: "Specialized team",
    differential3Desc:
      "Professionals in law, management, and technology with legal technical knowledge and a focus on quality.",

    // Hero
    heroTitle: "Free your legal team <span>from bureaucracy</span>",
    heroSubtitle:
      "All stages of your law firm's case monitoring mapped and executed in an assertive and secure manner.",
    talkToSpecialists: "Talk to our specialists",

    // Metrics
    processes: "Monitored processes",
    lawyers: "Assisted lawyers",
    years: "Years in the market",

    missionTitle: "Mission",
    missionText:
      "Provide our clients with external support based on expertise and excellence, so they can focus exclusively on representing their clients.",

    visionTitle: "Vision",
    visionText:
      "To be the best information management company by offering customized solutions focused on quality, productivity, cost reduction, and assertiveness.",

    valuesTitle: "Values",
    valuesList: [
      "Ethics",
      "Commitment",
      "Assertiveness",
      "Quality",
      "Agility",
      "Autonomy",
      "Honesty",
    ],
    clientsTitle: 'Some of our <span class="highlight">clients</span>',
    contactTitle: 'Get in <span class="highlight">touch</span>',
    contactCta: "Click here to chat",

    aboutTitle: 'About <span class="highlight">us</span>',
    aboutP1:
      "Founded in 2010 by partners Ligia Werneck and Nathália Amaral Araújo, archivists graduated from Universidade Federal Fluminense, Integrarq began its activities with archival consulting, offering services focused on physical collections.",
    aboutP2:
      "With resilience, we have adapted to market changes to meet our clients’ demands and have updated our portfolio of services. Today, we have an interdisciplinary team including professionals in law, management, and technology.",
    aboutP3:
      "While serving clients from various sectors, we have specialized in mass litigation firms of medium and large size. With expertise, we analyze and process information so that lawyers can focus on what truly matters: representing their clients.",

    // Problem
    problemTitle: 'The problem we <span class="highlight">solve</span>',
    wastedTime: "Wasted time",
    wastedTimeDesc:
      "Lawyers spend up to 40% of their time on tasks that don't involve their core expertise.",
    lostDeadlines: "Missed deadlines",
    lostDeadlinesDesc:
      "Failures in case monitoring can result in missed deadlines and opportunities.",
    bureaucracy: "Bureaucratic overload",
    bureaucracyDesc:
      "Excess administrative tasks that compete with time dedicated to advocacy.",

    // Services
    servicesTitle: 'Our <span class="highlight">services</span>',

    legalBackoffice: "Legal Backoffice",
    legalResearch: "Legal Research",
    documentManagement: "Document Management",
    documentManagementDesc:
      "Registration of cases, contracts, and clients. Organization and filing of digital procedural documents.",
    deadlineControl: "Deadline Management",
    deadlineControlDesc:
      "Scheduling of hearings, double-check of appointments, and personalized alerts.",
    operationalSupport: "Operational Support",
    operationalSupportDesc:
      "Paralegal routines, handling of new case updates, and tracking of appeals.",
    dataOrganization: "Database Organization",
    dataOrganizationDesc:
      "Cleaning of case database, data retrieval from courts, and verification of developments.",
    publications: "Publications",
    publicationsDesc:
      "Monitoring and delivery of relevant publications, ensuring that nothing goes unnoticed.",
    caseUpdates: "Case Updates",
    caseUpdatesDesc:
      "Tracking and continuous updating of procedural progress, keeping the team always informed.",
    electronicSummons: "Electronic Summons",
    electronicSummonsDesc:
      "Management of summons issued via electronic panels, ensuring quick response.",
    distributionsAndInquiries: "Distributions and Inquiries",
    distributionsAndInquiriesDesc:
      "Identification of new cases and detailed search by name or case number.",
    // Contact
    name: "Name",
    email: "Email",
    phone: "Phone",
    message: "Message",
    send: "Send message",

    testimonial1:
      "I have worked with Integrarq since the time they handled our firm’s paper archives. Over time, as technology advanced and cases became digital, Integrarq not only kept up with this transformation but reinvented itself. Today, they remain by our side, managing digital cases with the same competence as always and constantly bringing us new solutions and products.",
    testimonial1Client: "Janssen Murayama",

    testimonial2:
      "The accuracy in case monitoring and the continuous support from the Integrarq team were essential for the growth of our office.",
    testimonial2Client: "Office in Rio de Janeiro",

    testimonial3:
      "Integrarq is a true partner. They provide full support and implement solutions that streamline our internal operations.",
    testimonial3Client: "Office in São Paulo",

    testimonial4:
      "Integrarq performs essential legal control services, not only for deadline management, but also for identifying new cases. This allows the firm to offer clients early information and anticipate strategies. They also provide valuable data analysis to optimize resource allocation.",
    testimonial4Client: "Office in São Paulo",

    testimonial5:
      "Serious, efficient and objective service. Essential for any type of law firm. Congratulations on the success!",
    testimonial5Client: "Office in São Paulo",
  },

  es: {
    // Header
    home: "Inicio",
    problem: "El Problema",
    services: "Servicios",
    differentials: "Diferenciales",
    about: "Sobre",
    clients: "Clientes",
    contact: "Contacto",
    language: "Idioma",
    portuguese: "Portugués",
    english: "Inglés",
    spanish: "Español",
    italian: "Italiano",
    clientsTitle: 'Algunos de nuestros <span class="highlight">clientes</span>',
    contactTitle: 'Ponte en <span class="highlight">contacto</span>',
    contactCta: "Haz clic aquí para conversar",
    addressLabel: "Dirección",
    backofficeTitle: "Backoffice y Control de Procesos Jurídicos",
    quickLinks: "Enlaces rápidos",
    socialMedia: "Redes sociales",
    allRightsReserved: "Todos los derechos reservados.",
    testimonialsTitle:
      'Lo que <span class="highlight">nuestros clientes</span> dicen',

    // Hero
    heroTitle: "Libera a tu equipo legal <span>de la burocracia</span>",
    heroSubtitle:
      "Todas las etapas del seguimiento de casos de tu bufete mapeadas y ejecutadas de manera asertiva y segura.",
    talkToSpecialists: "Habla con nuestros especialistas",

    // Metrics
    processes: "Procesos monitoreados",
    lawyers: "Abogados asistidos",
    years: "Años en el mercado",
    differentialsTitle: 'Nuestros <span class="highlight">diferenciales</span>',

    differential1Title: "Trabajamos en TU plataforma",
    differential1Desc:
      "Adaptación a los sistemas ya utilizados (Legal One, LFM, Themis, etc.) sin necesidad de migración.",

    differential2Title: "Apoyo en la transición de sistemas",
    differential2Desc:
      "Implementación asistida, depuración de base de datos y documentación de rutinas para una migración fluida.",

    differential3Title: "Equipo especializado",
    differential3Desc:
      "Profesionales del derecho, la gestión y la tecnología con conocimientos técnicos jurídicos y enfoque en calidad.",

    // Problem
    problemTitle: 'El problema que <span class="highlight">resolvemos</span>',
    wastedTime: "Tiempo perdido",
    wastedTimeDesc:
      "Los abogados gastan hasta el 40% de su tiempo en tareas que no involucran su experiencia principal.",
    lostDeadlines: "Plazos perdidos",
    lostDeadlinesDesc:
      "Las fallas en el seguimiento de casos pueden resultar en la pérdida de plazos y oportunidades.",
    bureaucracy: "Sobrecarga burocrática",
    bureaucracyDesc:
      "Exceso de tareas administrativas que compiten con el tiempo dedicado a la abogacía.",

    aboutTitle: 'Sobre <span class="highlight">nosotros</span>',
    aboutP1:
      "Fundada en 2010 por sus socias Ligia Werneck y Nathália Amaral Araújo, archivistas graduadas en la Universidade Federal Fluminense, Integrarq inició sus actividades con asesoría archivística, ofreciendo servicios enfocados en acervos físicos.",
    aboutP2:
      "Con resiliencia, hemos acompañado los cambios del mercado para satisfacer las demandas de nuestros clientes y actualizamos nuestro portafolio de servicios. Actualmente contamos con un equipo interdisciplinario con profesionales del derecho, la gestión y la tecnología.",
    aboutP3:
      "Aunque atendemos a clientes de diversos sectores, nos especializamos en despachos jurídicos de litigios masivos de tamaño medio y grande. Con experiencia, analizamos y tratamos la información para que los abogados puedan centrarse en lo que realmente importa: la representación de sus clientes.",

    missionTitle: "Misión",
    missionText:
      "Proporcionar a nuestros clientes soporte externo con experiencia y excelencia, para que puedan centrarse exclusivamente en la representación de sus clientes.",

    visionTitle: "Visión",
    visionText:
      "Ser la mejor empresa de gestión de la información ofreciendo soluciones personalizadas con enfoque en calidad, aumento de productividad, reducción de costos y asertividad.",

    valuesTitle: "Valores",
    valuesList: [
      "Ética",
      "Compromiso",
      "Asertividad",
      "Calidad",
      "Agilidad",
      "Autonomía",
      "Honestidad",
    ],

    // Services
    servicesTitle: 'Nuestros <span class="highlight">servicios</span>',

    legalBackoffice: "Backoffice Legal",
    legalResearch: "Investigación Legal",
    documentManagement: "Gestión Documental",
    documentManagementDesc:
      "Registro de procesos, contratos y clientes. Organización y archivo de documentos procesales digitales.",
    deadlineControl: "Control de Plazos",
    deadlineControlDesc:
      "Agendamiento de audiencias, doble verificación de compromisos y alertas personalizadas.",
    operationalSupport: "Soporte Operativo",
    operationalSupportDesc:
      "Rutinas de paralegal, gestión de nuevos movimientos y seguimiento de recursos.",
    dataOrganization: "Organización de la Base",
    dataOrganizationDesc:
      "Saneamiento de la base de procesos, búsqueda de datos en los Tribunales y verificación de desarrollos.",
    publications: "Publicaciones",
    publicationsDesc:
      "Monitoreo y entrega de publicaciones relevantes, asegurando que nada pase desapercibido.",
    caseUpdates: "Seguimiento de Procesos",
    caseUpdatesDesc:
      "Rastreo y actualización continua de los avances procesales, manteniendo al equipo siempre informado.",
    electronicSummons: "Notificaciones Electrónicas",
    electronicSummonsDesc:
      "Gestión de notificaciones emitidas a través de paneles electrónicos, asegurando una respuesta rápida.",
    distributionsAndInquiries: "Distribuciones e Investigaciones",
    distributionsAndInquiriesDesc:
      "Identificación de nuevos procesos y búsqueda detallada por nombre o número de proceso.",
    // Contact
    name: "Nombre",
    email: "Correo electrónico",
    phone: "Teléfono",
    message: "Mensaje",
    send: "Enviar mensaje",

    testimonial1:
      "Trabajo con Integrarq desde la época en que gestionaban el archivo en papel del despacho. Con el tiempo y el avance de la tecnología, los procesos se digitalizaron, e Integrarq no solo siguió esta transformación, sino que se reinventó. Hoy siguen a nuestro lado, gestionando los procesos digitales con la misma competencia de siempre y brindándonos constantemente nuevas soluciones y productos.",
    testimonial1Client: "Janssen Murayama",

    testimonial2:
      "La precisión en el seguimiento de casos y el apoyo constante del equipo de Integrarq fueron fundamentales para el crecimiento de nuestro despacho.",
    testimonial2Client: "Despacho en Río de Janeiro",

    testimonial3:
      "Integrarq es una empresa aliada de sus clientes. Nos brinda total apoyo y viabiliza soluciones que facilitan el trabajo interno.",
    testimonial3Client: "Despacho en São Paulo",

    testimonial4:
      "Integrarq realiza un importante trabajo de control jurídico, no solo para el seguimiento de plazos, sino también para la detección de nuevas acciones, lo que permite al despacho anticiparse y brindar información de primera mano. También realizan análisis cuantitativos que ayudan a mejorar la asignación de recursos.",
    testimonial4Client: "Despacho en São Paulo",

    testimonial5:
      "Servicio serio, eficiente y objetivo. Esencial para cualquier modelo de despacho. ¡Felicidades por el éxito!",
    testimonial5Client: "Despacho en São Paulo",
  },

  it: {
    // Header
    home: "Inizio",
    problem: "Il Problema",
    services: "Servizi",
    differentials: "Differenziali",
    about: "Chi Siamo",
    clients: "Clienti",
    contact: "Contatto",
    language: "Lingua",
    portuguese: "Portoghese",
    english: "Inglese",
    spanish: "Spagnolo",
    italian: "Italiano",
    clientsTitle: 'Alcuni dei nostri <span class="highlight">clienti</span>',
    contactTitle: 'Mettiti in <span class="highlight">contatto</span>',
    contactCta: "Clicca qui per parlare",
    addressLabel: "Indirizzo",
    backofficeTitle: "Backoffice e Controllo Giuridico",
    quickLinks: "Link rapidi",
    socialMedia: "Social network",
    allRightsReserved: "Tutti i diritti riservati.",
    testimonialsTitle:
      'Cosa dicono <span class="highlight">i nostri clienti</span>',

    // Hero
    heroTitle: "Libera il tuo team legale <span>dalla burocrazia</span>",
    heroSubtitle:
      "Tutte le fasi del monitoraggio dei casi del tuo studio legale mappate ed eseguite in modo assertivo e sicuro.",
    talkToSpecialists: "Parla con i nostri specialisti",

    // Metrics
    processes: "Processi monitorati",
    lawyers: "Avvocati assistiti",
    years: "Anni nel mercato",
    differentialsTitle:
      'I nostri <span class="highlight">punti di forza</span>',

    differential1Title: "Lavoriamo sulla TUA piattaforma",
    differential1Desc:
      "Adattamento ai sistemi già utilizzati (Legal One, LFM, Themis, ecc.) senza necessità di migrazione.",

    differential2Title: "Supporto nella transizione dei sistemi",
    differential2Desc:
      "Implementazione assistita, pulizia del database e documentazione delle routine per una migrazione fluida.",

    differential3Title: "Team specializzato",
    differential3Desc:
      "Professionisti del diritto, della gestione e della tecnologia con competenze giuridiche e orientamento alla qualità.",

    missionTitle: "Missione",
    missionText:
      "Fornire ai nostri clienti supporto esterno con competenza ed eccellenza, affinché possano concentrarsi esclusivamente sulla rappresentanza dei propri clienti.",

    visionTitle: "Visione",
    visionText:
      "Essere la migliore azienda di gestione delle informazioni offrendo soluzioni personalizzate con focus su qualità, produttività, riduzione dei costi e assertività.",

    valuesTitle: "Valori",
    valuesList: [
      "Etica",
      "Impegno",
      "Assertività",
      "Qualità",
      "Agilità",
      "Autonomia",
      "Onestà",
    ],

    aboutTitle: 'Chi <span class="highlight">siamo</span>',
    aboutP1:
      "Fondata nel 2010 dalle socie Ligia Werneck e Nathália Amaral Araújo, archiviste laureate presso l’Universidade Federal Fluminense, Integrarq ha iniziato la propria attività con consulenze archivistiche, offrendo servizi rivolti ad archivi fisici.",
    aboutP2:
      "Con resilienza, abbiamo seguito i cambiamenti del mercato per soddisfare le esigenze dei nostri clienti e aggiornato il nostro portafoglio di servizi. Oggi contiamo su un team interdisciplinare con professionisti del diritto, della gestione e della tecnologia.",
    aboutP3:
      "Pur servendo clienti di diversi settori, ci siamo specializzati in studi legali di contenzioso massivo di medie e grandi dimensioni. Con competenza, analizziamo e trattiamo le informazioni affinché gli avvocati possano concentrarsi su ciò che conta davvero: rappresentare i propri clienti.",

    // Problem
    problemTitle: 'Il problema che <span class="highlight">risolviamo</span>',
    wastedTime: "Tempo sprecato",
    wastedTimeDesc:
      "Gli avvocati spendono fino al 40% del loro tempo in attività che non coinvolgono la loro competenza principale.",
    lostDeadlines: "Scadenze perse",
    lostDeadlinesDesc:
      "Errori nel monitoraggio dei casi possono comportare la perdita di scadenze e opportunità.",
    bureaucracy: "Sovraccarico burocratico",
    bureaucracyDesc:
      "Eccesso di compiti amministrativi che competono con il tempo dedicato all'avvocatura.",

    // Services
    servicesTitle: 'I nostri <span class="highlight">servizi</span>',

    legalBackoffice: "Backoffice Legale",
    legalResearch: "Ricerca Legale",
    documentManagement: "Gestione Documentale",
    documentManagementDesc:
      "Registrazione di procedimenti, contratti e clienti. Organizzazione e archiviazione di documenti processuali digitali.",
    deadlineControl: "Gestione delle Scadenze",
    deadlineControlDesc:
      "Pianificazione delle udienze, doppio controllo degli impegni e avvisi personalizzati.",
    operationalSupport: "Supporto Operativo",
    operationalSupportDesc:
      "Attività paralegali, gestione dei nuovi aggiornamenti e monitoraggio dei ricorsi.",
    dataOrganization: "Organizzazione della Base",
    dataOrganizationDesc:
      "Pulizia della base dei procedimenti, ricerca dei dati nei Tribunali e verifica degli sviluppi.",
    publications: "Pubblicazioni",
    publicationsDesc:
      "Monitoraggio e consegna delle pubblicazioni rilevanti, garantendo che nulla passi inosservato.",
    caseUpdates: "Aggiornamenti",
    caseUpdatesDesc:
      "Monitoraggio e aggiornamento continuo degli sviluppi processuali, mantenendo sempre informato il team.",
    electronicSummons: "Notifiche Elettroniche",
    electronicSummonsDesc:
      "Gestione delle notifiche emesse tramite pannelli elettronici, garantendo una risposta rapida.",
    distributionsAndInquiries: "Distribuzioni e Ricerche",
    distributionsAndInquiriesDesc:
      "Identificazione di nuovi procedimenti e ricerca dettagliata per nome o numero di procedimento.",
    // Contact
    name: "Nome",
    email: "Email",
    phone: "Telefono",
    message: "Messaggio",
    send: "Invia messaggio",
    testimonial1:
      "Collaboro con Integrarq da quando si occupavano dell’archivio cartaceo dello studio. Con il passare del tempo e l’avanzare della tecnologia, i procedimenti sono diventati digitali e Integrarq non solo ha seguito questa trasformazione, ma si è reinventata. Oggi sono ancora al nostro fianco, gestendo i processi digitali con la stessa competenza di sempre e portandoci continuamente nuove soluzioni e prodotti.",
    testimonial1Client: "Janssen Murayama",

    testimonial2:
      "La precisione nel monitoraggio dei procedimenti e il supporto costante del team Integrarq sono stati fondamentali per la crescita del nostro studio.",
    testimonial2Client: "Studio a Rio de Janeiro",

    testimonial3:
      "Integrarq è un partner affidabile. Ci offre pieno supporto e soluzioni che semplificano il lavoro interno.",
    testimonial3Client: "Studio a San Paolo",

    testimonial4:
      "Integrarq svolge un lavoro fondamentale di controllo legale, non solo per la gestione delle scadenze, ma anche per l’individuazione di nuovi procedimenti. Questo consente allo studio di fornire informazioni tempestive ai clienti e di anticipare le strategie. Un altro servizio utile è l’analisi quantitativa del lavoro svolto, che aiuta a ottimizzare l’allocazione delle risorse.",
    testimonial4Client: "Studio a San Paolo",

    testimonial5:
      "Servizio serio, efficiente e diretto. Essenziale per qualsiasi modello di studio legale. Complimenti per il successo!",
    testimonial5Client: "Studio a San Paolo",
  },
};